/* [
 {
 "client_id":=,
 "number_of_dependents":,
 "marital_status_cd_marital_status": "",
 "mothers_maiden_name": "",
 "profession_cd_profession": "",
 "email": "",
 "Address_Ownership_Type_cd_address_ownership_type": "",
 "current_address_years":
 "alternate_contact": ""
 }
 ]
 */

export default {
  CLIENT_ID: "client_id",
  NUMBER_OF_DEPENDENTS: "number_of_dependents",
  MARITAL_STATUS: "marital_status",
  MOTHERS_MAIDEN_NAME: "mothers_maiden_name",
  FATHER_NAME: "father_name",
  PROFESSION: "profession",
  EMAIL: "email",
  ADDRESS_OWNERSHIP_TYPE: "address_ownership_type",
  CURRENT_ADDRESS_YEARS: "current_address_years",
  CURRENT_ADDRESS_MONTHS: "current_address_months",
  CURRENT_CITY_YEARS: "current_city_years",
  CURRENT_CITY_MONTHS: "current_city_months",
  ALTERNATE_PHONE_NUMBER: "alternate_phone_number",
  LOCALE_STRING: "locale",
  LOCALE: "en_IN",

  getPersonalDetails(personalData) {
    let personalDetails = {}
    personalDetails[this.LOCALE_STRING] = this.LOCALE;
    if (personalData[this.MOTHERS_MAIDEN_NAME]) {
      personalDetails[this.MOTHERS_MAIDEN_NAME] = personalData[this.MOTHERS_MAIDEN_NAME]
    }
    if (personalData[this.FATHER_NAME]) {
      personalDetails[this.FATHER_NAME] = personalData[this.FATHER_NAME]
    }
    if (personalData[this.NUMBER_OF_DEPENDENTS]) {
      personalDetails[this.NUMBER_OF_DEPENDENTS] = parseInt(personalData[this.NUMBER_OF_DEPENDENTS])
    }
    if (personalData[this.MARITAL_STATUS]) {
      personalDetails[this.MARITAL_STATUS] = personalData[this.MARITAL_STATUS]
    }
    if (personalData[this.EMAIL]) {
      personalDetails[this.EMAIL] = personalData[this.EMAIL]
    }
    if (personalData[this.ADDRESS_OWNERSHIP_TYPE]) {
      personalDetails[this.ADDRESS_OWNERSHIP_TYPE] = personalData[this.ADDRESS_OWNERSHIP_TYPE]
    }
    if (personalData[this.CURRENT_ADDRESS_YEARS]) {
      personalDetails[this.CURRENT_ADDRESS_YEARS] = parseInt(
        personalData[this.CURRENT_ADDRESS_YEARS])
    }
    if (personalData[this.ALTERNATE_PHONE_NUMBER]) {
      personalDetails[this.ALTERNATE_PHONE_NUMBER] = personalData[this.ALTERNATE_PHONE_NUMBER]
    }
    return personalDetails;
  },

  getProfessionPayLoad(profession) {
    let personalDetails = {}
    personalDetails[this.PROFESSION] = profession
    return personalDetails
  }
}